// Client portal	Admi portal
// SIT	client-portal-sit.sktes.com	nexgen-admin-sit.sktes.com
// UAT	client-portal-uat.sktes.com	nexgen-admin-uat.sktes.com
// Live	client-portal.sktes.com	nexgen-admin.sktes.com
export const PORTAL_URL = `${window.location.protocol}//${window.location.host}`

export const APP_URL = `${PORTAL_URL}`
export const LOCAL_URL = `${PORTAL_URL}/cpadmin/api/v1`;
export const HOME_CUSTOMER_URL = `${PORTAL_URL}/cpadmin/api/v1`;
export const AUTH_SERVICE_URL = `${PORTAL_URL}/auth/api/v1`;

export const JIRA_COLLECTOR_SCRIPT_URL = 'https://servicedesk.tes-amm.com/plugins/servlet/issueCollectorBootstrap.js?collectorId=e0cc1b1f&locale=en_US';

export const API_REQUESTS = {
    // PROCESSLIST_URL :  '/cpadmin/requestDetails',
    PROGRAMS: "/portal",
    REQUEST_TYPE: "/RequestTypes",
    PROGRAM_REQUEST_TYPE: "/portalrequesttype",
    REQUEST_DETAILS: "/requestdetail",
    EMAIL_SEND: "/emailSends/mailSend",
    // REQUEST_ASSETS: '/RequestAssets',
    REQUEST_ASSETS: "/newrequestassets/createRecord",
    SAVE_ASSETS: "/newrequestassets/createAsset",
    UPDATE_ASSET: "/newrequestassets/updateAsset",
    DELETE_ASSETS: "/newrequestassets/deleteAsset",
    SAVE_SERVICE: "/newrequestassets/saveservice",
    NEW_REQUEST_ASSET: "/newrequestassets",
    PROGRAM_ASSETS: "/assetsportals",
    PROGRAM_ADDITIONAL_INFO: "/portaladditionalinfo",
    TES_SERVICES_TYPE: "/servicetype",
    TES_SERVICES: "/tesServices",
    CLIENT_SERVICE_TYPE_URL: "/clientservicetype",

    // LOGISTICS_OPTION : '/LogisticsWithRequestTypes',
    RECYLCLEPARTNER_LIST: '/ClientRecyclingPartners',
    PROGRAM_RECYLCLEPARTNER_LIST: '/recyclingpartnerportal',
    INIT_FORGOT_PSWD: '/portal/forgotPassword',
    CONFIRM_FORGOT_URL: '/portal/confirmPassword',
    UPLOAD_ASSET: '/newrequestassets/bulkUpload',
    STATUSES: '/requeststagestatuses',
    STATUSES_BY_REQUEST_LIST: '/listPortalStageStatusListByRequestList',
    GET_TERMS: '/termsandprivacies',
    // STATUSES : '/Statuses',
    COLLECTION_SITE: '/client/listPortalCollections',
    // GET_SAVED_SERVICES: '/newRequestAssets',
    EXCEL_AVAILABLE: '/assetexcels/count',
    ASSET_EXCEL: '/assetexcels/csvexport',
    ASSET_EXCEL_TEMPLATE: '/assetexcels/getTemplate',
    ASSET_EXCEL_REQ: '/assetexcels',
    SAVE_ASSET_EXCEL: '/assetexcels/createAsset',
    SAVE_ASSETS_WITH_PALLET: "/assetexcels/createAssetWithPalletId",
    DELETE_ASSETS_WITH_PALLET: "/assetExcels/deleteAssetWithPalletId",
    UPDATE_REQUEST_IN_PALLET: "/assetexcels/updateRequestInPallet",
    DELETE_REQUEST_IN_PALLET: "/assetexcels/deleteRequestInPallet",
    DELETE_ASSET_EXCEL: '/assetexcels/deleteAsset',
    SAVE_EXCEL_SERVICE: '/assetexcels/saveservice',
    UPDATE_EXCEL_SERVICE: '/assetexcels/updateAsset',
    PACKING_PORTAL_URL: '/packingportal',
    BOXES_LIST: '/portalboxes',
    LABELS_LIST: '/programLabel',
    ADDITIONAL_INFO: '/requestadditionalinfos',
    PROGRAM_REQUEST_STAGES: '/portalstagesequence',
    PROGRAM_WITH_REQUEST_STAGES: '/ProgramWithRequestStage',
    PROGRAM_REQUEST_STAGE_INPUTFILEDS: '/portalstageinputfield',
    GET_REPORTS: '/circleReports',
    REQUEST_PACKING: '/requestpackings',
    REQUEST_LABEL: '/requestlabels',
    GET_CLIENT_SERVICES: "/clientservices",
    REQUEST_SERVICE: '/requestservices',
    TRUCK_URL: '/trucklist',
    PROGRAM_REQUEST_STAGE_INPUTS: '/portalstageinputfield',
    PROGRAM_REQUEST_STAGE_STATUS: '/portalstagestatuses',
    PROGRAM_REQUEST_STATUS_ONLY_COMPLETED: '/portalRequestStageStatuses',
    REQUEST_STATUSES_PROGRESS_URL: '/requeststatusprogress',
    REQUEST_ADDRESS: "/requestAddresses",
    PROGRAM_COUNTRY_URL: '/portalcountry',
    REQUEST_QUOTE: '/quotecommunications',
    REQUEST_DOCS_URL: '/requestdocuments',
    PROGRAM_DOCUMENT_TYPE_URL: '/portaldocumenttypes',
    PO_URL: '/updateclientpos',
    PORTAL_ADDITIONAL_FIELDS: '/portaladditionalfields',
    REQUEST_ADDITIONAL_FIELDS: '/requestadditionalfields',
    USER_CONFIGURATION_URL: '/userconfigurations',
    SEARCH_FILTER_URL: '/searchfilters',
    REGION_URL: '/regions',
    RELEASE_NOTES_URL: '/releasenotes',
    USER_FEEDBACK_URL: '/userFeedbacks',
    USER_FEEDBACK_QUESTIONS: '/PortalUserFeedbackQuestions',
    PROGRAM_PACKINGS_URL: '/portalpacking',
    PROGRAM_PACKINGS_GRADE_URL: '/portalpackingfeegrade',
    SUPERVISOR_USER_ACCESS: '/userSupervisor',
    QUOTE_REQUEST_CONTACT: '/quoterequestcontacts',
    REQUEST_CONTACT_URL: '/requestcontacts',
    PORTAL_CONTACT_URL: '/portalcontacts',
    PROGRAM_COMPANY_URL: '/portalcompanies',
    RECURSIVE_REQ_URL: '/recursiverequests',
    UNIT_MEASUREMENT_TYPE: '/unitconversions',
    CARRIER_CONTACT: '/carriercontacts',
    PROGRAM_CARRIER_URL: '/programCarriers',
    PORTAL_CARRIER_URL:'/portalcarriers',
    PALLET_URL: '/pallets',
    //bulkupload User
    PORTAL_STORYBOARD_URL: '/dacp-dashboards',
    PROGRAM_BRANDS: "/ProgramBrands",
    ASSET_QUOTATION: "/newassetquotationrequests",
    PACKAGING_URL: "/portalpackingtypes",
    DIMENSIONS_URL: "/packagedimensions",
    PORTAL_CONTACTS: "/portalContacts",

    NOTIFICATION: "/notification",
    NOTIFICATION_USER: "/notificationuser",
    NOTIFICATION_USER_SETTING: "/notification-user-settings",
    RECENT_ACCESS: "/recent-access",
    NOTICES: "/notices",
    INQUIRY: "/inquiry",
    REQUEST_ACCESS: "/requestAccess",
    PORTAL_GROUP: "/portalgroups",
    INQUIRY_CATEGORIES: "/inquiryCategories",
    PORTAL_INQUIRY_CATEGORIES: "/portal-inquiry-categories",
};

export const AUTH_API = {
    FILE: "/file",
    INQUIRY : "/inquiry"
};

export const DEFAULT_ALL_COUNTRIES_ID = -10;

export const VALIDATE_REGEX = {
    // email: /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
    email: /[a-zA-Z0-9._]*@[a-zA-Z0-9.-]*\.[a-z]*/,
    phone: /^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/im
};

export const Service_Types = {
    Standard: "Standard",
    Extra: "Extra"
};

export const ICONS_LIST = [
    {
        name: "Box Icon",
        value: "tes-box"
    },
    {
        name: "Questionanaire List",
        value: "tes-questionnaire-list"
    },
    {
        name: "Delivery Truck Icon",
        value: "tes-delivery-truck"
    },
    {
        name: "Tes Calendar Icon",
        value: "tes-calander"
    },
    {
        name: "Schedule",
        value: "tesStatusIconsSchedule",
        path: 27
    },
    {
        name: "Reporting Done",
        value: "tesStatusIconsReportingDone",
        path: 8
    },
    {
        name: "Processing Done",
        value: "tesStatusIconsprocess",
        path: 17
    },
    {
        name: "Reached Facility",
        value: "tesStatusIconsFacility",
        path: 13
    },
    {
        name: "Completed",
        value: "tesStatusIconsComplete",
        path: 8
    },
    {
        name: "Approve",
        value: "tesStatusIconsApproved",
        path: 14
    },
    {
        name: "Cancel",
        value: "tesStatusIconsCancel",
        path: 14
    },
    {
        name: "New",
        value: "tesStatusIconsNew",
        path: 14
    },
    {
        name: "Donation Sent",
        value: "tesStatusIconsDonationSent",
        path: 30
    },
    {
        name: "COD Completed",
        value: "tesStatusIconsCodDone",
        path: 14
    },
    {
        name: "Quote Requested",
        value: "tesStatusIconsQuoteRequested",
        path: 14
    },
    {
        name: "Quote Sent",
        value: "tesStatusIconsQuoteSent",
        path: 15
    },
    {
        name: "Quote Accepted",
        value: "tesStatusIconsQuoteAccepted",
        path: 14
    },
    {
        name: "Quote Declined",
        value: "tesStatusIconsQuoteDeclined",
        path: 14
    },
]

export const REPORT_MODULE_NAMES = [
    {
        displayName: "Reports Display",
        name: "Reports Display"
    },
    {
        displayName: "Reports Search",
        name: "Reports Search"
    },
    {
        displayName: "Reception Reports",
        name: "Reception Reports"
    },
    {
        displayName: "Booking Reports",
        name: "Booking Reports"
    },
    {
        displayName: "Value Back Reports",
        name: "Value Back Reports"
    },
    {
        displayName: "Revenue Share Reports",
        name: "Revenue Share Reports"
    },
    {
        displayName: "ServiceFee booking Reports",
        name: "ServiceFee booking Reports"
    },
    {
        displayName: "Miscellaneous Reports",
        name: "Miscellaneous Reports"
    },
    {
        displayName: "Settlement Reports",
        name: "Settlement Reports"
    },
    {
        displayName: "Portal Docs",
        name: "Portal Docs"
    }
];

export const COD_AVAILABLE_REPORTS = [
    {
        displayName: 'Value Back Reports',
        name: 'Value Back Reports'
    },
    {
        displayName: 'Revenue Share Reports',
        name: 'Revenue Share Reports'
    },
    {
        displayName: 'ServiceFee booking Reports',
        name: 'ServiceFee booking Reports'
    }
];

/* stage which the default will be QR_CODE_USER */
export const STAGES_DEFAULT_QR_CODE_USER = [
    { name: "Asset Images", matchkey: "asset_image" },
    { name: "Asset Details", matchkey: "asset-details" }
];

/* stage which the default will be QR_CODE_GENERATOR */
export const STAGES_DEFAULT_QR_CODE_GENERATOR = [
    { name: "SK Tes Services", matchkey: "service-detail" },
    { name: "Request Details", matchkey: "request-detail" }
];


export const PAGE_CODE = {
    COMMON_CODE: "CommonCode",
    CP_SIDEMENU: "SideMenu",
    CP_DASHBOARD: "Dashboard",
    CP_DOCUMENT: "Document",
    CP_NEWREQ: "NewRequest",
    CP_REQDOCS: "RequestDocuments",
    CP_ASSETQUE: "AssetsQueue",
    CP_REPORTS: "Reports",
    CP_USERS: "Users",
    CP_GROUPS: "Groups",
    CP_COMPANIES: "Companies",
    CP_RECURSIVE: "Recursive",
    CP_COLLECTIONADDRESS: "CollectionAddress",
    CP_PORTALDOCS: "PortalDocuments",
    CP_VISUALREPORTS: "VisualizationReports",
    CP_KPI_DASHBOARD: "KPIDashboard",
    CP_REGISTER_FORM: "RegisterForm",
    CP_FAQS: "FAQs",
    SUPPORT: "Support",
    CP_NEWINQUIRY: "NewInquiryForm",
    SETTING: "Setting",
    CP_REQUESTDOCS: "RequestDocs", // might not be using
    CP_REQSUM: "RequestSummary",
    CP_HOME: "Home",
    CP_HOME_RAISE_REQ: "HomeRequestRaise",
    // CP_INTRODUCTION: "Introduction",
    // CP_GETTINGSTARTED: "GettingStarted",
    // CP_MYACCOUNT: "MyAccount",
    // CP_APIDOCUMENT: "APIDocument",
    // CP_HOME_REQSUM: "HomeRequestSummary",
    // CP_HOME_NAVBAR: "HomeNavbar",
    // CP_HOME_USERS: "HomeUsers",
    // CP_HOME_DEV_PORTAL: "HomeDeveloperPortal",
    // CP_QRCODE_REQUEST: "QRCodeRequest",
    // CP_PALLET_DASHBOARD: "PalletDashboard",
};

export const CONSIDER_AS_LARGE_FILE = 9 * 1024 * 1024;
export const LIMIT_LARGE_FILE_SIZE = 100 * 1024 * 1024;

export const SERVICE_TYPES = {
    StandardServices: "Standard Services",
    ExtraServices: "Extra Services and Quotable Services"
}

export const DEFAULT_STATUS_KEYS = {
    PENDING: 'pending',
    QUOTATION_STATUS: 'quote_requested',
    QUOTATION_DONE_STATUS: 'quote_completed',
    QUOTATION_SENT: 'quotation_sent',
    QUOTATION_APPROVED: 'quote_accepted',
    QUOTATION_REJECTED: 'quote_declined',
    CANCEL: 'cancel',
    QUOTATION_CANCELLED: 'quote_cancelled',
    NEW: 'new',
    APPROVED: 'approved',
    REACHED_FACILITY: 'reached_facility',
    PROCESSING_DONE: 'processing_done',
    REPORTING_DONE: 'reporting_done',
    COMPLETED: 'completed',
    COD_DONE: 'cod_done',
    COD_COMPLETED: 'cod_completed',
    DONATION_SENT: 'donation_sent',
    SCHEDULE_DATE: 'schedule_date_status',
    DELIVERED_DATE: 'delivered_date',
    PACKING_INITIATED: 'packing_initiated',
    AUDIT_BOOKING_REPORT: 'audit_booking_report',
    BOOKING_REPORTS: 'booking_reports',
    RECEPTION_REPORTS: 'reception_reports',
    RECYCLING_RECEPTION_REPORTS: 'recycling_reception_reports',
    REVENUE_SHARE_REPORTS: 'revenue_share_reports',
    SERVICEFEE_BOOKING_REPORTS: 'servicefee_booking_reports',
    SETTLEMENT_REPORTS: 'settlement_reports',
    VALUE_BACK_REPORTS: 'value_back_reports',
    PENDING_FOR_COLLECTION: 'pending_for_collection',
    PENDING_EXPORT_TO_SG: 'pending_export_to_SG',
    PENDING_EXPORT_PCBA_TO_SG: 'pending_export_PCBA_to_SG',
    IN_TRANSIT: 'in_transit',
    PROCESSING: 'processing',
    PREPARING_FOR_SETTLEMENT: 'preparing_for_settlement',
    READY_FOR_SETTLEMENT: 'ready_for_settlement',
    PENDING_IO_INVOICE: 'pending_IO_invoice',
    SETTLEMENT_CLOSED: 'settlement_closed',
    PROCESSING_STARTED: 'processing_started'
};

export const VOC_TRACKING_STATUS = {
    Open: "Open",
    Reopen: "Reopen",
    Resolved: "Resolved",
    CantReproduce: "Can't Reproduce",
    Declined: "Declined",
    ReportUploaded: "Report uploaded",
    AccessGiven: "Access given",
}

export const VOC_STATUS = {
    WFS: "Waiting for support",
    WFC: "Waiting for customer",
    Resolved: "Resolved",
}

export const VOC_CATEGORY = {
    GeneralInquiry: "General Inquiry",
    OnlinePortal: "Online Portal/Technical Support",
    RequestStatus: "Request Status",
    LogisticsInquiry: "Logistics Inquiry",
    RequestForDocuments: "Request for Documents",
    Invoice: "Invoice/ Settlement Support",
    RequestForAccess: "Request for Access"
}

export const PRIORITY = [
    { value: 1, label: "Highest" },
    { value: 2, label: "High" },
    { value: 3, label: "Medium" },
    { value: 4, label: "Lowest" },
    { value: 5, label: "Blocker" },
    { value: 6, label: "Minor" }
]